import ResetPasswordForm from 'components/modules/auth/ResetPasswordForm';
import AuthCardLayout from 'layouts/AuthCardLayout';

const ResetPassword = () => {
  document.title = process.env.REACT_APP_NAME + ' | Reset Password';
  return (
    <AuthCardLayout>
      <ResetPasswordForm />
    </AuthCardLayout>
  );
};

export default ResetPassword;
